import dayjs from "dayjs";

const lang = document.documentElement.lang;

const handleValidations = (ev, validations) => {
    const formErrors = document.getElementById("form-errors");
    formErrors.classList.add("hidden");
    formErrors.innerHTML = "";

    const data = new FormData(ev.target);
    const errors = [];

    try {
        Object.entries(validations).forEach(([key, { conditions }]) => {
            const value = data.get(key);
            conditions.forEach((condition) => {
                switch (condition.validation) {
                    case "required":
                        if (!value) {
                            errors.push({
                                field: key,
                                error: condition.message[lang],
                            });
                            return;
                        }
                        break;
                    case "years":
                        const onDate = dayjs(condition.date); // 2025-08-07
                        const birthDate = dayjs(value);
                        const ageOnDate = onDate.diff(birthDate, "year");

                        if (
                            ageOnDate < condition.min ||
                            ageOnDate > condition.max
                        ) {
                            errors.push({
                                field: key,
                                error: condition.message[lang],
                            });
                            return;
                        }
                        break;
                }
            });
        });
    } catch (error) {
        console.error(error);
    }

    if (errors.length > 0) {
        ev.preventDefault();
        ev.stopPropagation();

        errors.forEach((error) => {
            formErrors.innerHTML += `<div class="text-red-600 bg-red-50 border border-red-200 p-6">${error.error}</div>`;
        });

        formErrors.classList.remove("hidden");
    }
};

window.handleValidations = handleValidations;
